import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function LandingHome() {
    const { t } = useTranslation();
    return (
        <div className="relative h-screen">
            <video
                className="absolute inset-0 w-full h-full object-cover"
                src="https://petra-ms.com/landing-video.mp4"
                autoPlay
                loop
                muted
            />
            <img
                src={require("../../assets/image/1.jpg")}
                alt="Hero Fallback"
                className="w-full h-full object-cover hidden"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-[#097698]/60 to-[#075f72]/30 backdrop-blur-md flex items-center justify-center">
                <div
                    className="text-center px-6"
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                >
                    <h1 className="text-5xl md:text-7xl font-extrabold text-white mb-6 tracking-tight">
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#b58630] to-[#d4a35a] typing">
                            {t("OMA: Vision Redefined")}
                            <span className="cursor">|</span>
                        </span>
                    </h1>
                    <p className="text-xl md:text-3xl text-gray-100 max-w-3xl mx-auto mb-10 font-light">
                        {t("Elevate your style with sunglasses crafted for elegance and innovation.")}
                    </p>
                    <Link
                        to="/collections"
                        className="inline-block bg-[#b58630] text-white py-4 px-10 rounded-full font-bold text-xl hover:bg-[#a57729] transition-transform transform hover:scale-110 shadow-lg glow"
                    >
                        {t("Explore Collections")}
                    </Link>
                </div>
            </div>
        </div>
    );
}